<template>
  <Teacher style="margin-top: -81px;"></Teacher>
</template>

<script>
  import Teacher from '@/page/modules/teacher/detail'
  export default {
    components: { Teacher }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/teacher/model.vue